import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, timeoutWith } from 'rxjs/operators';
import { CONSTANTS } from '@cue-admin/constants';

import { ConfigService } from '@cue-admin/config';
import { ServersPageModel, ApiResponseModel } from '@cue-admin/shared-data';

@Injectable({
  providedIn: 'root',
})
export class ServersService {
  private http = inject(HttpClient);
  private config = inject(ConfigService);

  private get apiUrl(): string {
    const config = this.config.value;
    if (!config) {
      throw new Error('Application config is not loaded.');
    }

    return config.apiURL;
  }

  actionLoad(): Observable<ApiResponseModel<ServersPageModel>> {
    const url = `${this.apiUrl + CONSTANTS.entity.server}`;
    return this.http.get<ApiResponseModel<ServersPageModel>>(url).pipe(
      timeoutWith(30000, throwError({ status: CONSTANTS.myError.timeoutError })),
      map((response: ApiResponseModel<ServersPageModel>) => {
        return response as ApiResponseModel<ServersPageModel>;
      })
    );
  }
}
